import { render, staticRenderFns } from "./estoque.vue?vue&type=template&id=4ad5a546&scoped=true&"
import script from "./estoque.vue?vue&type=script&lang=js&"
export * from "./estoque.vue?vue&type=script&lang=js&"
import style0 from "./estoque.vue?vue&type=style&index=0&id=4ad5a546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5a546",
  null
  
)

export default component.exports